import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithubSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons";

const CONTACTS = [
  {
    href: "https://github.com/Ahmed-Arafa757",
    icon: faGithubSquare,
    label: "GitHub",
    className: "me-2"
  },
  {
    href: "https://www.linkedin.com/in/ahmedarafa757/",
    icon: faLinkedin,
    label: "LinkedIn",
    className: ""
  }
];

export const Contacts = () => (
  <div id="contacts" className="row">
    <h3 className="col-12 text-center mt-3">LET'S GET IN TOUCH</h3>
    <div className="col-12 text-center mb-4">
      {CONTACTS.map(({ href, icon, label, className }) => (
        <a
          key={label}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
        >
          <FontAwesomeIcon className={`fa-3x${className ? ` ${className}` : ""}`} icon={icon} />
        </a>
      ))}
    </div>
    <span className="cr col-12 text-center mb-3">
      Copyright © Ahmed Arafa {new Date().getFullYear()}, All Rights Reserved.
    </span>
  </div>
);
